export const APP_ENVIRONMENTS = {
  BUILD: 'build',
  BUILD_DEV: 'build_dev',
  DEV: 'development',
  GAMEDEV: 'gamedev',
  PROD: 'prod',
};

const isDevelopmentMode = process.env.APP_MODE === 'development';
const APPLICATION_MODE = process.env.APP_MODE;

export const APP_BASE_PATH = 'docs';

// if true, means app is in runtime mode, else build phase or local development mode
export const isAppRuntime =
  APPLICATION_MODE &&
  ![APP_ENVIRONMENTS.BUILD, APP_ENVIRONMENTS.BUILD_DEV].includes(APPLICATION_MODE) &&
  !isDevelopmentMode;
